import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight, Images } from 'lucide-react';
import { Button } from './ui/button';

const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/04dqnidl_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Landscaping & Walkways",
    category: "Landscaping"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/vp8xbud7_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Retaining Wall at Sunset",
    category: "Retaining Walls"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/4gto9qil_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Limestone Retaining Wall",
    category: "Retaining Walls"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/vjutchm0_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Outdoor Living Space",
    category: "Hardscapes"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/gonv9igt_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Pathway with Lighting",
    category: "Hardscapes"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/jaggcswr_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Paver Patio Design",
    category: "Hardscapes"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/kmqtt04h_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Front Yard Landscaping",
    category: "Landscaping"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/3lueeevj_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Professional Lawn Mowing",
    category: "Lawn Care"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/y5j81pux_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Patio with Fire Pit",
    category: "Hardscapes"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/hyy32lsf_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Fall Clean Up",
    category: "Lawn Care"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/ys3853fl_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Mulching & Tree Care",
    category: "Mulching"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/nvod81ww_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Front Yard Design",
    category: "Landscaping"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/qy59lv49_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Stone Edging & Flowers",
    category: "Landscaping"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/0xvbsz73_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Lakeside Landscape",
    category: "Landscaping"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/u1tn1atw_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Lakeside Patio",
    category: "Hardscapes"
  },
  {
    id: 16,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/k6i4no5g_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Tree Mulching Service",
    category: "Mulching"
  },
  {
    id: 17,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/834gzgce_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Foundation Landscaping",
    category: "Landscaping"
  },
  {
    id: 18,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/p2te8cie_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Decorative Stone Edging",
    category: "Landscaping"
  },
  {
    id: 19,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/ezczmgp4_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Lawn Edging Detail",
    category: "Lawn Care"
  },
  {
    id: 20,
    url: "https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/gw3wbmkd_PHOTO-2026-01-26-12-34-00.jpeg",
    title: "Irrigation System Turn On",
    category: "Irrigation"
  }
];

const categories = ["All", "Hardscapes", "Landscaping", "Retaining Walls", "Lawn Care", "Mulching", "Irrigation"];

const Gallery = () => {
  const [showAll, setShowAll] = useState(false);
  const [activeCategory, setActiveCategory] = useState("All");
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredImages = activeCategory === "All" 
    ? galleryImages 
    : galleryImages.filter(img => img.category === activeCategory);

  const displayedImages = showAll ? filteredImages : filteredImages.slice(0, 3);

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const navigateImage = (direction) => {
    const currentIndex = filteredImages.findIndex(img => img.id === selectedImage.id);
    let newIndex;
    if (direction === 'next') {
      newIndex = (currentIndex + 1) % filteredImages.length;
    } else {
      newIndex = currentIndex === 0 ? filteredImages.length - 1 : currentIndex - 1;
    }
    setSelectedImage(filteredImages[newIndex]);
  };

  const handleCategoryChange = (category) => {
    setActiveCategory(category);
    setShowAll(false);
  };

  return (
    <section id="gallery" className="py-20 bg-bg-page">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="inline-flex items-center gap-2 bg-brand-primary/10 border border-brand-primary/30 rounded-full px-4 py-2 mb-6">
            <span className="text-brand-dark text-sm font-semibold">
              Our Work
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-6">
            Project Gallery
          </h2>
          <p className="text-text-secondary text-lg leading-relaxed">
            Browse through our recent projects and see the quality craftsmanship
            we bring to every job.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => handleCategoryChange(category)}
              className={`px-5 py-2.5 rounded-full font-medium transition-all duration-300 ${
                activeCategory === category
                  ? 'bg-brand-dark text-white shadow-lg'
                  : 'bg-bg-card text-text-secondary hover:bg-brand-primary/10 hover:text-brand-dark'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayedImages.map((image) => (
            <div
              key={image.id}
              onClick={() => openLightbox(image)}
              className="group relative rounded-2xl overflow-hidden cursor-pointer aspect-square shadow-lg"
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/80 via-brand-dark/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <span className="text-brand-primary text-sm font-medium">
                  {image.category}
                </span>
                <h3 className="text-white font-bold text-lg">{image.title}</h3>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        {filteredImages.length > 3 && (
          <div className="text-center mt-10">
            <Button
              onClick={() => setShowAll(!showAll)}
              className="bg-brand-dark text-white hover:bg-brand-hover rounded-full px-8 py-6 text-lg font-semibold inline-flex items-center gap-3 transition-all duration-300 hover:-translate-y-1 shadow-lg"
            >
              <Images size={22} />
              {showAll ? 'Show Less' : `View All ${filteredImages.length} Projects`}
            </Button>
          </div>
        )}

        {/* Lightbox */}
        {selectedImage && (
          <div 
            className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
            onClick={closeLightbox}
          >
            {/* Close Button */}
            <button
              onClick={closeLightbox}
              className="absolute top-4 right-4 text-white/70 hover:text-white p-2 transition-colors z-10"
              aria-label="Close"
            >
              <X size={32} />
            </button>

            {/* Navigation Buttons */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                navigateImage('prev');
              }}
              className="absolute left-4 text-white/70 hover:text-white p-3 bg-white/10 hover:bg-white/20 rounded-full transition-all z-10"
              aria-label="Previous image"
            >
              <ChevronLeft size={28} />
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                navigateImage('next');
              }}
              className="absolute right-4 text-white/70 hover:text-white p-3 bg-white/10 hover:bg-white/20 rounded-full transition-all z-10"
              aria-label="Next image"
            >
              <ChevronRight size={28} />
            </button>

            {/* Image */}
            <div 
              className="max-w-5xl max-h-[85vh] relative"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={selectedImage.url}
                alt={selectedImage.title}
                className="max-w-full max-h-[85vh] object-contain rounded-lg"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 rounded-b-lg">
                <span className="text-brand-primary text-sm font-medium">
                  {selectedImage.category}
                </span>
                <h3 className="text-white font-bold text-xl">
                  {selectedImage.title}
                </h3>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;
